import { render } from "./CampoFecha.vue?vue&type=template&id=322f1779"
import script from "./CampoFecha.vue?vue&type=script&lang=js"
export * from "./CampoFecha.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__